import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { IViewsDropdown } from "../../../src/taskpane/interfaces/IViewsDropdown";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Views(viewsWithColumns: IViewsDropdown[], selectedView: IViewsDropdown, setSelectedView: (view: IViewsDropdown) => void, quickFilterValue: string, libraryMinVerEnabled: boolean) {
  const languageStrings = React.useContext(LanguageContext);

  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);
  const minVersionLimit = useSelector((state: RootState) => state.tenantInfo?.minVersionLimit);

  const [menuItem_Views, setMenuItem_Views] = React.useState<IContextualMenuItem>();
  const [viewItems, setViewItems] = React.useState<IContextualMenuItem[]>([]);

  React.useEffect(() => {   
    if (!searchValue && !quickFilterValue) {
      setMenuItem_Views(
        {
          key: "views",
          disabled: viewsWithColumns.length === 0 || isBusySaving === true,
          text: selectedView ? selectedView.text : languageStrings.Views,
          iconProps: { iconName: "List" },
          subMenuProps: {
            items: viewItems
          }
        }
      )
    } else {
      setMenuItem_Views(null);
    }
  }, [viewItems, viewsWithColumns, isBusySaving, searchValue, quickFilterValue]);

  React.useEffect(() => {
    const views: IContextualMenuItem[] = [];

    viewsWithColumns.forEach(view => {
      const viewItem: IContextualMenuItem = {
        key: view.key.toString(),
        canCheck: true,
        checked: view.key === selectedView?.key,
        text: view.text,
        onClick: () => setSelectedView(view)
      }

      if (!view.isReport || (view.isReport && libraryMinVerEnabled && minVersionLimit)) {
        views.push(viewItem);
      }
    });

    setViewItems([...views])

  }, [viewsWithColumns, selectedView, libraryMinVerEnabled, minVersionLimit]);

  return {
    menuItem_Views
  }

}